import React from "react";
import { ShoppingCart, CalendarBlank } from "@phosphor-icons/react";
import styled from "styled-components";
import { useTranslation } from "react-i18next";
import { colors } from "../../../styles/theme";

const Wrapper = styled.div`
  display: flex;
  flex-direction: column;
  align-items: center;
  justify-content: center;
  height: 100%;
  min-height: 400px;
  padding: 40px 24px;
  text-align: center;
`;

const IconCircle = styled.div`
  width: 80px;
  height: 80px;
  border-radius: 50%;
  background: ${colors.primaryLight};
  display: flex;
  align-items: center;
  justify-content: center;
  margin-bottom: 24px;
`;

const Title = styled.h2`
  font-size: 20px;
  font-weight: 600;
  color: ${colors.textPrimary};
  margin: 0 0 8px 0;
`;

const Description = styled.p`
  font-size: 14px;
  color: ${colors.textSecondary};
  margin: 0;
  max-width: 380px;
  line-height: 1.6;
`;

const Hint = styled.p`
  font-size: 13px;
  color: ${colors.textSecondary};
  margin: 16px 0 0 0;
  max-width: 380px;
  line-height: 1.6;
`;

// ---

interface Props {
  type: "orders" | "reservations";
}

export const OrdersEmptyState: React.FC<Props> = ({ type }) => {
  const { t } = useTranslation();
  const isOrders = type === "orders";

  return (
    <Wrapper>
      <IconCircle>
        {isOrders
          ? <ShoppingCart size={36} color={colors.primary} weight="regular" />
          : <CalendarBlank size={36} color={colors.primary} weight="regular" />
        }
      </IconCircle>

      <Title>
        {isOrders ? t("emptyState.ordersTitle") : t("emptyState.servicesTitle")}
      </Title>
      <Description>
        {isOrders ? t("emptyState.ordersDesc") : t("emptyState.servicesDesc")}
      </Description>
      <Hint>
        {isOrders ? t("emptyState.ordersHint") : t("emptyState.servicesHint")}
      </Hint>
    </Wrapper>
  );
};
